import src from "IMAGE";
export default { src, width: 351, height: 75, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AHBwcG1kZGRgbW1taWlpaWZ3d3dyYmJiX0xMTEiTk5OHAIODg350dHRwjY2NiJ2dnZiioqKeh4eHhGpqamVvb29mqYEdxwH8vrsAAAAASUVORK5CYII="};
